"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "How do you handle complex jewelry models?",
  answer: "For highly detailed models, we utilize advanced CAD techniques to ensure every intricate detail is captured. While standard designs range from $50 to $200, complex pieces are quoted individually based on the technical requirements and time involved to ensure structural integrity for casting."
}, {
  question: "What are the bulk pricing options for 3D printing?",
  answer: "Our 3D printing services are optimized for production runs, with a minimum order requirement of 7 pieces. Prices range from $15 to $150 per piece depending on the resin type and volume. For larger production batches, please email us for a custom quote."
}, {
  question: "What is the typical turnaround time for a project?",
  answer: "Standard CAD designs are typically delivered within 3-5 business days. Once the design is approved, 3D printing and wax sample preparation take an additional 2-4 days. We prioritize precision to ensure your final cast is perfect."
}, {
  question: "Which file formats will I receive for my designs?",
  answer: "Every CAD project includes industry-standard .3dm and .stl files, ensuring compatibility with most casting houses and 3D printers. We also provide high-resolution .jpg renderings so you can showcase the design to your clients before production."
}, {
  question: "How do I submit a job for a custom quote?",
  answer: "The best way to start is by emailing us with your sketches, reference images, or technical specifications. We will review your requirements and provide a detailed quote for both the CAD design and 3D printing phases of your project."
}];
export default function CommonQuestions() {
  return <section data-section-id="224143" id="pricing-faq" className="w-full py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-primary mb-4">
            Service & Pricing FAQ
          </h2>
          <p className="text-lg text-muted-foreground font-default">
            Everything you need to know about our digital craftsmanship and jewelry production process.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq, i) => <AccordionItem key={i} data-index={i} value={`item-${i}`} className="bg-card/40 backdrop-blur-md border border-border rounded-md px-4 shadow-md">
              <AccordionTrigger className="font-serif font-bold text-left text-base md:text-lg hover:no-underline hover:text-secondary transition-colors py-5">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-5 font-default">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}